/**
 * @deprecated Este arquivo foi migrado para src/lib/corel/actions/session.ts
 * Use: import { SessionService } from './corel/actions/session'
 * 
 * Mantido temporariamente para compatibilidade
 */

import { SessionService } from './corel/actions/session';

/**
 * @deprecated Use SessionService.ensureToken() da nova API centralizada
 * 
 * Compatibilidade: Esta função ainda funciona mas delega para SessionService
 */
export async function ensureSessionHelloOnce(timeoutMs: number = 3000): Promise<boolean> {
  const result = await SessionService.ensureToken({ timeoutMs });
  return result.success;
}


